import React from 'react';

import {Triple3dCarouselBackwardArrow} from './triple-3d-container.backward-arrow';
import {Triple3dCarouselForwardArrow} from './triple-3d-carousel.forward-arrow';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {Triple3dCarouselItem} from "./triple-3d-carousel.item-container";
import {TripleCarouselComposer} from "./triple-carousel-composer";
import {Swipeable, SwipeableProps} from "../../swipeable/swipeable";
import styles from "../styles/triple-3d-carousel.module.scss";
import classNames from "classnames";

export class Triple3dCarouselProps extends BaseProps {
  isRtl: Boolean;
  showArrows: Boolean;
  slideEnabled: Boolean;
  activeItemWidth: Number;
  currentDegrees: Number;
  angle: Number;
  radius: Number;
  className: String;
  itemClassName: String;
  activeItemClassName: String;
  handleSlidePrevious: Function;
  handleSlideNext: Function;
  isActiveItem: Function;
  isSecondaryItem: Function;
  onItemClick: Function;
  onChange: Function;
  ArrowComponent: Function;
  minDistanceBetweenItems: Number;
  itemsShouldOverlap: Boolean;
  secondaryItemScale: Number;
}

export const Triple3dCarousel = TripleCarouselComposer((props: Triple3dCarouselProps) => {
  const backwardArrowProps = {
    isRtl: props.isRtl,
    onClickPrev: () => props.handleSlidePrevious()
  }

  const forwardArrowProps = {
    isRtl: props.isRtl,
    onClickNext: () => props.handleSlideNext()
  }

  const tripleCarouselProps = {
    className: classNames(styles.triple_3d_carousel),
    style: {transform: 'rotateY(' + props.currentDegrees + 'deg)'}
  }

  const itemContainerProps = {
    radius: props.radius,
    angle: props.angle,
    currentDegrees: props.currentDegrees,
    itemClassName: props.itemClassName,
    activeItemClassName: props.activeItemClassName,
    secondaryItemScale: props.secondaryItemScale,
  };

  const swipeableProps: SwipeableProps = {
    onSwipedLeft: () => props.slideEnabled && props.handleSlideNext(),
    onSwipedRight: () => props.slideEnabled && props.handleSlidePrevious(),
  };

  return (
    <Swipeable {...swipeableProps}>
      <div className={classNames(styles.triple_3d_carousel)}>
        {
          props.showArrows ? (props.ArrowComponent ? <props.ArrowComponent {...backwardArrowProps} isPrev={true} onClick={() => props.handleSlidePrevious()}/> :
                  <Triple3dCarouselBackwardArrow {...backwardArrowProps}/>)
           : null
      }
        <div className={classNames(props.className, styles.container)}>
            <div {...tripleCarouselProps}>
              {
                React.Children.map(props.children, (child, index: Number) =>
                  <Triple3dCarouselItem
                    itemIndex={index}
                    isActiveItem={(index) => props.isActiveItem(index)}
                    isSecondaryItem={(index) => props.isSecondaryItem(index)}
                    onItemClick={(index) => props.onItemClick(index)}
                    onClick={(index) => props.onItemClick(index)}
                    {...itemContainerProps}
                  >{child}</Triple3dCarouselItem>)
              }
            </div>
        </div>
        {
          props.showArrows ? (props.ArrowComponent ? <props.ArrowComponent {...forwardArrowProps}  onClick={() => props.handleSlideNext()}/> :
              <Triple3dCarouselForwardArrow {...forwardArrowProps}/>)
              : null
        }
      </div>
    </Swipeable>
  )
});